// extracted by mini-css-extract-plugin
export var horizontalLine = "team-page-module--horizontal-line--rZ+dv";
export var piquassoCommunity = "team-page-module--piquasso-community--7AxhC";
export var actionBtn = "team-page-module--action-btn--fh5Se";